import React from "react";

const OrderStatusGreen = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_581" transform="translate(-1360 -557)">
        <g
          id="Ellisse_23"
          transform="translate(1365 562)"
          fill="#26a557"
          stroke="#fff"
          strokeWidth="1"
        >
          <circle cx="11" cy="11" r="11" stroke="none" />
          <circle cx="11" cy="11" r="10.5" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default OrderStatusGreen;
